<template>
  <div id="setmall">
    <div class="br-contentpanel no-filtrate" :data-min="leftSideStatus">
      <Header />
      <div class="card mg-x-50 pd-20 mg-y-20 card-subuser">
        <div class="form-group row mg-b-0" style="align-items: stretch">
          <div class="col-md-5 col-sm-12 align-items-center mg-b-0">
            <div
              class="
                pos-relative
                mg-t-30
                pd-25 pd-xs-40
                rounded
                bd bd-white-2
                bg-black-3
              "
            >
              <ul class="login-tab d-flex pd-0 mg-0 wd-100p">
                <li class="wd-50p" :class="mode == 1 ? 'active' : ''">
                  <a href="javascript:;" @click="modeChange('1')">{{
                    $t("other.按物流单号出库")
                  }}</a>
                </li>
                <li class="wd-50p" :class="mode == 2 ? 'active' : ''">
                  <a href="javascript:;" @click="modeChange('2')">{{
                    $t("other.按物流单号 + 重量出库")
                  }}</a>
                </li>
              </ul>
              <div class="mg-b-15">
                <input
                  class="form-control tx-16 tx-bold"
                  id="iptCode"
                  type="text"
                  :placeholder="$t('other.物流单号')"
                  v-model.trim="trackNumber"
                  @keyup.enter="checkout($event)"
                />
              </div>
              <div class="mg-b-30 d-flex align-items-center" v-if="mode == 2">
                <input
                  class="mg-r-5 form-control tx-16 tx-bold"
                  id="iptWgt"
                  type="text"
                  :placeholder="$t('other.包裹重量')"
                  v-WEIGHT
                  v-model.number="weight"
                  @keyup.enter="checkout($event)"
                />
                <span>{{ $t("other.克") }}</span>
              </div>
              <div
                class="
                  tx-center
                  d-flex
                  align-items-center
                  justify-content-center
                "
              >
                <button class="mg-r-15 btn btn-primary" @click="checkout()">
                  {{ $t("other.提交") }}
                </button>
                <button class="btn btn-secondary" @click="reset">
                  {{ $t("other.重置") }}
                </button>
              </div>
            </div>
          </div>
          <div class="col-md-7 col-sm-12">
            <div
              class="pos-relative pd-0 rounded bd bd-white-2 bg-black-3"
              style="height: 100%"
            >
              <div v-if="showCard.type" style="height: 100%">
                <div
                  class="card pd-y-15"
                  style="height: 100%"
                  :class="
                    showCard.type == 1
                      ? 'border-success bg-success'
                      : 'border-danger bg-danger'
                  "
                >
                  <div class="row mg-b-15">
                    <div class="col-12 tx-18 tx-center tx-white">
                      {{
                        showCard.type == 1
                          ? $t("other.出库成功！")
                          : $t("other.出库失败！")
                      }}
                    </div>
                  </div>
                  <div class="row mg-b-15 tx-16 tx-white">
                    <div class="col-4 tx-right">
                      {{ $t("other.物流单号：") }}
                    </div>
                    <div class="col-8 tx-bold">{{ showCard.expressCode }}</div>
                  </div>
                  <div
                    v-if="showCard.weight"
                    class="row mg-b-15 tx-16 tx-white"
                  >
                    <div class="col-4 tx-right">
                      {{ $t("other.包裹称重：") }}
                    </div>
                    <div class="col-8">
                      <span class="tx-bold">{{ showCard.weight }}</span>
                      {{ $t("other.克") }}
                    </div>
                  </div>
                  <div v-if="showCard.type == 1" class="row tx-16 tx-white">
                    <div class="col-4 tx-right">
                      {{ $t("other.快递渠道：") }}
                    </div>
                    <div class="col-8">
                      <span class="tx-bold">{{ showCard.companyName }}</span>
                    </div>
                  </div>
                  <div v-if="showCard.type == 2" class="row tx-16 tx-white">
                    <div class="col-4"></div>
                    <div class="col-8">
                      <span class="tx-bold">{{ showCard.errorMsg }}</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div v-if="items.length" class="card mg-x-50 pd-20 mg-y-20">
        <table class="table mg-b-0 table-contact bill data-table">
          <thead>
            <tr>
              <td>{{ $t("other.物流单号") }}</td>
              <td>{{ $t("other.物流公司") }}</td>
              <td>{{ $t("other.订单号") }}</td>
              <td>{{ $t("other.重量") }}</td>
              <td>{{ $t("other.状态") }}</td>
              <td>{{ $t("other.时间") }}</td>
            </tr>
          </thead>
          <tbody>
            <tr v-for="item in items" :key="item.time">
              <td>
                {{ item.expressCode }}
              </td>
              <td>{{ item.companyName }}</td>
              <td>{{ item.code }}</td>
              <td>{{ item.weight }}</td>
              <td>
                <span :class="item.type == 1 ? 'tx-success' : 'tx-danger'">
                  {{ item.type == 1 ? $t("other.成功") : item.errorMsg }}
                </span>
              </td>
              <td>{{ item.time }}</td>
            </tr>
          </tbody>
        </table>
      </div>
      <api-loading :show="loading"></api-loading>
    </div>
  </div>
</template>

<script>
import Header from "./header.vue"; //$t('other.头')
export default {
  data() {
    return {
      leftSideStatus: true,
      loading: false,
      mode: 1,
      trackNumber: "",
      weight: "",
      showCard: {
        type: "",
        code: "",
        companyName: "",
        expressCode: "",
        weight: "",
        time: "",
        errorMsg: "",
      },
      items: [],
    };
  },
  components: {
    Header,
  },
  methods: {
    playSound(type) {
      let src = type == "success" ? "audio/save.mp3" : "audio/error.mp3";
      var borswer = window.navigator.userAgent.toLowerCase();
      if (borswer.indexOf("ie") >= 0) {
        //IE$t('other.内核浏览器')
        var strEmbed =
          '<embed name="embedPlay" src="' +
          src +
          '" autostart="true" hidden="true" loop="false"></embed>';
        if ($("body").find("embed").length <= 0) $("body").append(strEmbed);
        var embed = document.embedPlay;

        //$t('other.浏览器不支持') audion$t('other.，则使用') embed $t('other.播放')
        embed.volume = 100;
        //embed.play();$t('other.这个不需要')
      } else {
        //$t('other.非')IE$t('other.内核浏览器')
        var strAudio = '<audio id="audioPlay" src="' + src + '" hidden="true">';
        if ($("body").find("audio").length <= 0) {
          $("body").append(strAudio);
          var audio = document.getElementById("audioPlay");
        } else {
          $("body").find("audio").remove();
          $("body").append(strAudio);
          var audio = document.getElementById("audioPlay");
        }
        //$t('other.浏览器支持') audion
        audio.play();
      }
    },
    modeChange(type) {
      this.mode = type;
      document.getElementById("iptCode").focus();
    },
    reset() {
      this.mode = 1;
      this.trackNumber = "";
      this.weight = "";
    },
    checkout(event) {
      if (!this.isSysRights("Order.checkOutgoing")) return;
      if (event && this.mode == 2 && event.target.id == "iptCode") {
        document.getElementById("iptWgt").focus();
        return;
      }
      if (!this.trackNumber) {
        ShowTip(this.$t("other.请输入物流单号"), "danger");
        document.getElementById("iptCode").focus();
        return false;
      }
      if (!this.weight && this.mode == 2) {
        console.log(2);
        document.getElementById("iptWgt").focus();
        ShowTip(this.$t("other.请输入重量"), "danger");
        return false;
      }
      this.loading = true;
      let [trackNumber, weight] = [this.trackNumber, this.weight];
      $.api_call(
        "api.Order.checkOutgoing",
        {
          trackNumber,
          weight,
        },
        (r) => {
          this.loading = false;
          document.getElementById("iptCode").focus();
          if (r.ErrorCode == "9999") {
            let data = r.Data.Results;
            if (data.length) {
              this.playSound("success");
              this.showCard = {
                type: 1,
                code: data[0].code,
                companyName: data[0].companyName,
                expressCode: data[0].expressCode,
                weight: data[0].weight,
                time: moment().format("M月DD日 H:mm:ss"),
              };
            } else {
              this.playSound("fail");
              this.showCard = {
                type: 2,
                code: "",
                companyName: "",
                expressCode: trackNumber,
                weight,
                time: moment().format("M月DD日 H:mm:ss"),
                errorMsg: this.$t("other.未找到相关的销售订单"),
              };
            }
            this.items.unshift(this.showCard);
            this.trackNumber = "";
            this.weight = "";
          } else {
            document.getElementById("iptCode").select();
            this.playSound("fail");
            if (r.ErrorCode == "1002") {
              userFailure(this);
            } else {
              this.showCard = {
                type: 2,
                code: "",
                companyName: "",
                expressCode: trackNumber,
                weight,
                time: moment().format("M月DD日 H:mm:ss"),
                errorMsg: r.Message,
              };
              this.items.unshift(this.showCard);
            }
          }
        }
      );
    },
  },
  mounted() {
    document.getElementById("iptCode").focus();
  },
};
</script>
<style lang="less" scoped>
input[type="text"]:focus {
  box-shadow: 0 0 4px #55a6f8;
  background-color: #c4e0fd;
}
</style>